/**
 * `?org=` names the organisation a page shows. Three forms are accepted:
 * - our slug: `de`, `it`, `es`;
 * - the GAM platform's organisation slug: `gam-medical`, `gam-italy`, `gam-es` (the platform fills
 *   its `{org}` placeholder with these, and rewrites `?org=` to them on links it stores);
 * - a patient domain, e.g. `onboarding.gam-medical.it` (resolved by the server).
 */
export const PLATFORM_ORG_SLUGS: Readonly<Record<string, string>> = { 'gam-medical': 'de', 'gam-italy': 'it', 'gam-es': 'es' }

/** The value to resolve: a platform slug becomes ours, anything else is passed on unchanged. */
export function orgParamForResolve(value: string | null | undefined): string | null {
  if (!value) return null
  return PLATFORM_ORG_SLUGS[value.trim().toLowerCase()] ?? value
}

/** Our slug when `?org=` names an organisation directly; null for a domain or nothing. */
export function orgSlugFromParam(value: string | null | undefined): string | null {
  const v = (value ?? '').trim().toLowerCase()
  if (!v) return null
  if (PLATFORM_ORG_SLUGS[v]) return PLATFORM_ORG_SLUGS[v]
  return /^[a-z][a-z0-9-]{0,39}$/.test(v) ? v : null
}
